// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2ce7cc6f691af6357973","655":"b46103140b4c5d4a9558"}[chunkId] + ".js";
};